export const Pages = {
	'Frequent questions': 'Frequent questions',
};
